(() => {
  const selector = '[data-release-date]';
  const dayMilliseconds = 86400000;
  const pendingBadges = new Set();
  let scheduled = false;

  const nzCalendar = new Intl.DateTimeFormat('en-NZ', {
    timeZone: 'Pacific/Auckland',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });

  const releaseFormatter = new Intl.DateTimeFormat('en-NZ', {
    timeZone: 'UTC',
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });

  function currentNZDay() {
    const values = {};

    for (const part of nzCalendar.formatToParts(new Date())) {
      values[part.type] = part.value;
    }

    return Date.UTC(
      Number(values.year),
      Number(values.month) - 1,
      Number(values.day)
    ) / dayMilliseconds;
  }

  function updateBadge(badge, today) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(
      badge.dataset.releaseDate || ''
    );

    let label = '';
    let outNow = false;

    if (match) {
      const releaseTime = Date.UTC(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3])
      );

      const daysUntil = releaseTime / dayMilliseconds - today;

      if (daysUntil > 3) {
        label = `Releases ${releaseFormatter.format(releaseTime)}`;
      } else if (daysUntil === 3) {
        label = 'Releases in 3 days';
      } else if (daysUntil === 2) {
        label = 'Releases in 2 days';
      } else if (daysUntil === 1) {
        label = 'Releases tomorrow';
      } else if (daysUntil <= 0 && daysUntil >= -13) {
        label = 'Out Now';
        outNow = true;
      }
    }

    if (badge.textContent !== label) {
      badge.textContent = label;
    }

    badge.classList.toggle('release-date-badge--out-now', outNow);
    badge.hidden = !label;
  }

  function flush() {
    scheduled = false;
    const today = currentNZDay();

    for (const badge of pendingBadges) {
      if (badge.isConnected) updateBadge(badge, today);
    }

    pendingBadges.clear();
  }

  function collect(root) {
    if (root instanceof Element && root.matches(selector)) {
      pendingBadges.add(root);
    }

    root.querySelectorAll(selector).forEach((badge) => {
      pendingBadges.add(badge);
    });
  }

  function schedule() {
    if (scheduled || pendingBadges.size === 0) return;
    scheduled = true;
    requestAnimationFrame(flush);
  }

  function start() {
    collect(document);
    flush();

    const content = document.querySelector('main') || document.body;

    const observer = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          // Ignore text changes, including our own label updates.
          if (!(node instanceof Element)) continue;
          collect(node);
        }
      }

      schedule();
    });

    observer.observe(content, {
      childList: true,
      subtree: true
    });

    document.addEventListener('shopify:section:load', (event) => {
      collect(event.target);
      schedule();
    });

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        collect(document);
        schedule();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
